export default __webpack_public_path__ + "static/media/title-landing.bf71f65c.svg";